<mat-dialog-content>
  <div>
    <h1 style="text-align: center; font-size: 18px">
      <strong>Avanzar Orden de Alquiler</strong>
    </h1>
    <h2 style="text-align: left" class="rental-order-text">Orden #{{ data.$event.consecutive }}</h2>
    <h2 style="text-align: left" class="rental-order-text">Cliente: {{ data.$event.providerName }}</h2>
    <h2 style="text-align: left" class="rental-order-text">
      Dirección: {{ data.$event.providerAddress }}
    </h2>
    <h2 style="text-align: left" class="rental-order-text">
      Estado Actual: {{ data.$event.stateName }}
    </h2>

    <form
      [formGroup]="formPutRO"
      (ngSubmit)="
        formPutRO.valid ? updateRetalOrder(formPutRO.value) : errorMessage()
      "
    >
      <div class="first-row">
        <div class="row-item">
          <mat-form-field [appOpenDatepickerOnClick]="pickerDate"> 
            <mat-label>Fecha</mat-label>
            <input
              [matDatepicker]="pickerDate"
              autocomplete="off"
              matInput
              required
              formControlName="date"
            />
            <mat-datepicker-toggle matIconSuffix [for]="pickerDate">
            </mat-datepicker-toggle>
            <mat-datepicker
              #pickerDate
              [touchUi]="movil ? true : false"
            ></mat-datepicker>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>        
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <mat-label>Hora</mat-label>
            <input
              matInput
              [ngxTimepicker]="pickerH"
              [disableClick]="true"
              formControlName="time"
              required
              readonly
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="togglePicker()"
            >
              <mat-icon>access_time</mat-icon>
            </button>
            <ngx-material-timepicker
              #pickerH
              (opened)="onPickerOpened()"
              (closed)="onPickerClosed()"
            ></ngx-material-timepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <input
              autocomplete="off"
              type="text"
              formControlName="comment"
              matInput
              #comentario
              maxlength="255"
              placeholder="Comentario"
            />
            <mat-hint>{{ comentario.value.length }}/255</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-top: 30px;
        "
      >
        <button
          style="width: 60%"
          color="primary"
          class="button-save mat-elevation-z5 mt-3"
          type="submit"
          mat-raised-button
        >
        {{ data.$event.stateId === 2 ? 'Entregado' : (data.$event.stateId === 3 ? 'Recibido' : 'Aceptar') }}
        </button>
      </div>
    </form>
  </div>
</mat-dialog-content>
